type FeedbackType = "network" | "js";

interface AlpineDataInterface {
  displayNetworkFeedback: boolean;
  displayJSFeedback: boolean;
  timer: ReturnType<typeof setTimeout> | null;
  showAfter: (feedbackType: FeedbackType, delay: number) => void;
  hide: (feedbackType: FeedbackType) => void;
}

function alpineData(): AlpineDataInterface {
  return {
    displayNetworkFeedback: false,
    displayJSFeedback: false,
    timer: null,
    showAfter(feedbackType: FeedbackType, delay: number): void {
      if (feedbackType === "network") {
        console.log("Slow request detected");
        this.timer = setTimeout(() => {
          this.displayNetworkFeedback = true;
        }, delay);
      }
      if (feedbackType === "js") {
        this.timer = setTimeout(() => {
          this.displayJSFeedback = true;
        }, delay);
      }
    },
    hide(feedbackType: FeedbackType): void {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      if (feedbackType === "network") this.displayNetworkFeedback = false;
      if (feedbackType === "js") this.displayJSFeedback = false;
    },
  };
}

export default alpineData;
